<template>
  <div class="py-4 container-fluid">
    <GridRow class="pb-4">
      <GridCol lg="12">
        <div class="d-flex flex-row justify-content-between gap-2">
          <div>
            <h5>Hai, {{ this.$store.state.sessionUser.employee?.name ?? "" }}</h5>
            <p>Selamat datang kembali, silakan cek kembali KPI saat ini</p>
          </div>
        </div>
        <div class="d-flex flex-row justify-content-start gap-2">
          <div class="d-flex flex-row gap-2 justify-content-start">
            <FormGroup class="m-0 filter">
              <model-list-select
                class="form-control"
                v-model="unit_kerja_id"
                :list="list_unit_kerja.sort((a, b) => a.name.localeCompare(b.name))"
                option-value="id"
                option-text="name"
                placeholder="Semua Unit Kerja"
              />
            </FormGroup>
            <FormGroup class="m-0 filter">
              <model-list-select
                class="form-control"
                v-model="jabatan_id"
                :list="list_jabatan.sort((a, b) => a.name.localeCompare(b.name))"
                option-value="id"
                option-text="name"
                placeholder="Semua Jabatan"
              />
            </FormGroup>
            <FormGroup class="m-0 filter">
              <model-list-select
                class="form-control"
                v-model="periode_id"
                :list="list_periode.sort((a, b) => a.name.localeCompare(b.name))"
                option-value="id"
                option-text="name"
                placeholder="Semua Periode"
              />
            </FormGroup>
          </div>
        </div>
      </GridCol>
    </GridRow>
    <GridRow>
      <GridCol lg="12">
        <GridRow v-if="this.$store.state?.sessionUser?.groups?.[0]?.label === 'pegawai'">
          <GridCol
            v-for="(item, index) in statistics_kpi"
            :key="index"
            :md="3"
            class="mb-4"
          >
            <cards :withmin="false">
              <div class="text-center">
                <strong>{{ item?.nama_periode || '-' }}</strong>
                <p class="mb-0 text-xs">{{ item?.mulai_periode && item?.selesai_periode ? item?.mulai_periode +' s.d. '+ item?.selesai_periode : '' }}</p>
                <h1 class="text-xl" style="font-size: 72px;">{{ item?.indeks_penilaian || '-' }}</h1>
                <argon-badge :color="indeks_label?.[item?.indeks_penilaian]?.color || 'secondary'">
                  {{ indeks_label?.[item?.indeks_penilaian]?.label || '-' }}
                </argon-badge>
              </div>
            </cards>
          </GridCol>
        </GridRow>
        <GridRow v-if="this.$store.state?.sessionUser?.groups?.[0]?.label === 'pegawai'">
          <GridCol
            v-for="(item, index) in statistics"
            :key="index"
            :md="3"
            class="mb-4"
          >
            <cards :withmin="false">
              <p class="">{{ item?.title || '-' }}</p>
              <div class="text-center">

                <doughnut-chart
                  :v_id="`chart-slide-${index}`"
                  :colors="[(keterangan_label?.[item?.keterangan]?.chart || '#000'),'#E4E9EF']"
                  :circumference="180"
                  :rotation="270"
                  :cvheight="165"
                  text="KPI Terealisasi"
                  :chartData="item?.chart?.data || [0, 0]"
                  :labels=" ['Sudah Dikerjakan', 'Belum Dikerjakan']"
                />

                <argon-badge :color="keterangan_label?.[item?.keterangan]?.label || 'secondary'" class="mt-4">
                  <span class="text-capitalize">{{ item?.keterangan ? item?.keterangan?.replaceAll('_', ' ') : '-' }}</span>
                </argon-badge>
              </div>
            </cards>
          </GridCol>
        </GridRow>

        <GridRow v-else>
          <GridCol
            v-for="(item, index) in statistics_kpi"
            :key="index"
            :md="3"
            class="mb-4"
          >
            <cards :withmin="false">
              <p class="">{{ item?.title || '-' }}</p>
              <div class="text-center">

                <doughnut-chart
                  :v_id="`chart-slide-${index}`"
                  :colors="[(keterangan_label?.[item?.keterangan]?.chart || '#000'),'#E4E9EF']"
                  :circumference="180"
                  :rotation="270"
                  :cvheight="165"
                  text="KPI Terealisasi"
                  :chartData="item?.chart?.data || [0, 0]"
                  :labels=" ['Sudah Dikerjakan', 'Belum Dikerjakan']"
                />

                <argon-badge :color="keterangan_label?.[item?.keterangan]?.label || 'secondary'" class="mt-4">
                  <span class="text-capitalize">{{ item?.keterangan ? item?.keterangan?.replaceAll('_', ' ') : '-' }}</span>
                </argon-badge>
              </div>
            </cards>
          </GridCol>
        </GridRow>
      </GridCol>
    </GridRow>
  </div>
</template>
<script>
import Cards from "../components/CardComponent.vue";
import GridRow from '../components/grid/GridRow.vue';
import GridCol from '../components/grid/GridCol.vue';
import ArgonBadge from '../components/ArgonBadge.vue';
import DoughnutChart from '../components/DoughnutChart.vue';

import KpiPeriodeApi from '../repository/api/KpiPeriodeApi';
import UnitKerjaApi from '../repository/api/UnitKerjaApi';
import JabatanApi from '../repository/api/JabatanApi';
import DashboardApi from '@/repository/api/DashboardApi';
import { ModelListSelect } from "vue-search-select";
import "vue-search-select/dist/VueSearchSelect.css";
import FormGroup from "@/components/FormGroup.vue";

export default {
  name: "dashboard-default",
  components: {
    FormGroup,
    Cards,
    GridRow,
    GridCol,
    ArgonBadge,
    DoughnutChart,
    ModelListSelect,
  },
  data() {
    return {
      is_loading: false,

      list_unit_kerja: [],
      list_jabatan: [],
      list_periode: [],

      periode_id: '',
      unit_kerja_id: '',
      jabatan_id: '',
      
      employee: {},
      statistics_kpi: [],
      statistics: [],
      indeks_label: {
        A: {
          label: 'Memuaskan',
          color: 'success',
        },
        B: {
          label: 'Baik',
          color: 'info',
        },
        C: {
          label: 'Cukup',
          color: 'primary',
        },
        D: {
          label: 'Kurang',
          color: 'warning',
        },
        E: {
          label: 'Sanget Kurang',
          color: 'danger',
        },
        F: {
          label: 'Sanget Kurang',
          color: 'danger',
        },
      },
      keterangan_label: {
        memuaskan: {
          label: 'success',
          chart: '#18981D',
        },
        baik: {
          label: 'info',
          chart: '#0385F3',
        },
        cukup: {
          label: 'warning',
          chart: '#F0B429',
        },
        perlu_peningkatan: {
          label: 'danger',
          chart: '#F90006',
        },
      },
    };
  },
  watch: {
    periode_id(newVal) {
      if (newVal && !this.is_loading) {
        this.getData();
      }
    },
    unit_kerja_id(newVal) {
      if (newVal && !this.is_loading) {
        this.getJabatan();
      }
    },
    jabatan_id(newVal) {
      if (newVal && !this.is_loading) {
        this.getData();
      }
    },
  },
  methods: {
    async getPeriode() {
      await KpiPeriodeApi.getbyparam({ page: "all", status: "active" })
        .then((response) => {
          this.list_periode = response?.data;
          this.periode_id = this.list_periode?.[0]?.id || '';
        }).catch(() => {
          this.list_periode = [];
        });
    },
    async getUnitKerja() {
      this.$store.state.loading = true;
      await UnitKerjaApi.getbyparam({
        page: 'all',
        status: 'active',
      })
        .then((response) => {
          this.list_unit_kerja = response?.data;
          this.unit_kerja_id = this.list_unit_kerja?.[0]?.id || '';
        }).catch(() => {
          this.list_unit_kerja = [];
        });
      this.$store.state.loading = false;
    },
    async getJabatan() {
      this.$store.state.loading = true;
      await JabatanApi.getbyparam({
        unitkerja_id: this.unit_kerja_id,
        page: 'all',
      })
        .then((response) => {
          this.list_jabatan = response?.data;
          this.jabatan_id = this.list_jabatan?.[0]?.id || '';
        }).catch(() => {
          this.list_jabatan = [];
        })
      this.$store.state.loading = false;
    },
    async getData() {
      this.$store.state.loading = true;

      if (this.$store.state?.sessionUser?.groups?.[0]?.label === 'pegawai') {
        await DashboardApi.getKpiPegawai({
          employee_id: this.employee?.id,
          periode_id: this.periode_id,
          unitkerja_id: this.employee?.unitkerja?.id,
          jabatan_id: this.employee?.jabatan_id,
        })
          .then((resp) => {
            this.statistics = resp?.data;
          }).catch((err) => {
            console.log(err)
            this.statistics = [];
          });
      }

      await DashboardApi.getData({
        view_as: this.$store.state?.sessionUser?.groups?.[0]?.label,
        employee_id: this.employee?.id,
        periode_id: this.periode_id,
        unitkerja_id: this.unit_kerja_id,
        jabatan_id: this.jabatan_id,
      })
        .then((resp) => {
          this.statistics_kpi = resp?.data;
        }).catch((err) => {
          console.log(err)
          this.statistics_kpi = [];
        });

      this.$store.state.loading = false;
    },
  },
  async mounted() {
    this.$store.state.loading = true;

    await this.getSessionUser();
    this.employee = this.$store.state?.sessionUser?.employee;

    if (this.$store.state?.sessionUser?.groups?.[0]?.label && this.$store.state?.sessionUser?.groups?.[0]?.label !== 'pegawai') {
      this.is_loading = true;

      await this.getPeriode();
      await this.getUnitKerja();
      await this.getJabatan();
      
      this.is_loading = false;
      await this.getData();

    } else {
      await this.getPeriode();
      await this.getData();
    }

    this.$store.state.loading = false;
  },
};
</script>
